import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';

// COMPONENTS
import Accounts from './cards/accounts.component';
import { CanOrNotFound } from 'permissions';

// STYLES
import { SettingsPageContent } from 'styles/settings';

// CONSTANTS
import { DotAppRoute, FleetSettingsSideMenuItem, UserPermission } from 'constants/common';

export default () => {
  const intl = useIntl();

  return (
    <CanOrNotFound I={UserPermission.VIEW} a={DotAppRoute.SETTINGS} field={FleetSettingsSideMenuItem.USERS}>
      <SettingsPageContent constraintToScreenHeight>
        <Helmet>
          <title>
            {intl.formatMessage({
              id: 'views.Settings.helmetTitle',
            })}
          </title>
          <meta
            name="settings"
            content={intl.formatMessage({
              id: 'views.Settings.helmetDescription',
            })}
          />
        </Helmet>
        <Accounts />
      </SettingsPageContent>
    </CanOrNotFound>
  );
};
